<script>
    export let ghosted = false;
</script>

<style>

    div {
        width: 1000px;
        border: 2px dashed white;
        border-radius: 12px;
        margin: 42px 20px 0 20px;
        max-width: 100%;
        padding: 60px 0;
    }

    .ghosted{
        border: none;
    }

</style>

<div class:ghosted={ghosted}><slot/></div>